import React from 'react';
import { motion } from 'framer-motion';

const ContactSales = () => {
  return (
    <div className="min-h-screen py-20">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-4xl mx-auto px-4"
      >
        <h1 className="text-4xl font-bold text-center mb-8">Contact Sales</h1>
        <p className="text-xl text-gray-600 text-center mb-12">
          Get in touch with our sales team to learn more about CareTrackAI
        </p>
        {/* Contact form will be implemented in future updates */}
      </motion.div>
    </div>
  );
};

export default ContactSales;